import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import Transformers from './transformers';

const excelExport = (fileName, columns, dataSource) => {
  try {
    const header = columns.map((item) => item.title);
    const excelKeys = columns.map((item) => item.key);
    const rows = dataSource.map((item) =>
      Transformers.getExcelRow(excelKeys, item)
    );

    const fileType = 'application/octet-stream';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.aoa_to_sheet([header].concat(rows));
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const file = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(file, fileName + fileExtension);
  } catch (e) {
    console.error('Excel indirme hatası:', fileName, columns, dataSource);
    console.error(e);
    return false;
  }
};

export default excelExport;
